import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const MessengerModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <path
          fill={fillColor200}
          opacity="0.25"
          d="M571.92,638.77C653.34,547,839,445.33,755.76,345.47c-58-69.6-253.93-156.8-468.88-184.77C-263.25,89.13,264.27,985.52,571.92,638.77Z"
          transform="translate(-47.24 -73.83)"
        />
        <g>
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M270.84,637.38c1.83,38.34,24,74.4,61.34,91.71,49.85,23.11,110.06,3.6,137.65-44.65.18-.32.37-.64.55-1a104.21,104.21,0,0,1,30.77-33.88,64.91,64.91,0,0,0,21.27-25.68c14.61-31.5,1.53-69.27-29.22-84.55-11.91-5.92-42.2-9-65.45-10.9-15.69-1.3-27.31-6.15-35-19.92C384,492.88,355.46,477.79,333,483.2c-42.09,10.16-47.76,21.09-70,58.77-10,16.9-29,33.67-.95,59.59C269.63,608.59,270.35,627,270.84,637.38Z"
            transform="translate(-47.24 -73.83)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M397,183.33c-13.32-34.19-45.33-60.88-86.07-66.57-54.42-7.59-105.81,26.14-117.48,77.15-.08.34-.15.68-.23,1a93.55,93.55,0,0,1-19,38.86,58.18,58.18,0,0,0-12.47,28.92c-4.38,32.39,19.48,63.06,53.35,68.67,13.12,2.18,42.86-3.14,65.57-7.62,15.32-3,27.84-1.73,39.31,8.68,13,11.83,44.79,17.84,64.49,7,37-20.43,39.07-31.83,48.88-71.87,4.41-18,17.39-38.2-17.1-54.16C406.89,209.06,400.65,192.62,397,183.33Z"
            transform="translate(-47.24 -73.83)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M646.49,505.57c38.3-2.4,74-25.13,90.78-62.7,22.37-50.19,2-110.1-46.69-137l-1-.53a104.17,104.17,0,0,1-34.34-30.27,64.85,64.85,0,0,0-26-20.88c-31.72-14.14-69.29-.5-84.11,30.47-5.74,12-8.35,42.33-9.92,65.61-1.06,15.7-5.74,27.4-19.4,35.28-15.53,9-30.18,37.76-24.44,60.11,10.78,41.92,21.79,47.43,59.8,69.15,17,9.75,34.11,28.46,59.6.06C617.72,507.21,636.09,506.22,646.49,505.57Z"
            transform="translate(-47.24 -73.83)"
          />
        </g>
        <path
          fill={fillColor600}
          d="M121.91,631.69c6.29,12,20.08,17.35,39.9,23.61,18.25,5.76,37-1.85,39.38-4.8,10.9-13.69-30.26-44.52-42.26-43.22C145.3,608.74,113.25,615.18,121.91,631.69Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M689.12,537.16c4.81-25-23.48-22.66-33.91-15.09-12.62,9.17,12.24,41.06,25,50.88C700.65,585.18,687,548.43,689.12,537.16Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M469,645c128-53.93,271.74-260.46,189.17-421.93-49.69-97.2-265.41,28.33-382.63-12.29C171.13,174.59,19.29,834.48,469,645Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M203.15,143.57c.45-29.66,37.38,1.33,46.65,15.39s.95,26.27-13.11,35.53-45.83,13.85-55.09-.21S202.55,182.86,203.15,143.57Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M319.25,492.5v99.67h99.67V492.5"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M506.13,243.33H232a87.21,87.21,0,0,0-87.2,87.21v137a24.92,24.92,0,0,0,24.91,24.92H568.42a24.93,24.93,0,0,0,24.92-24.92v-137A87.22,87.22,0,0,0,506.13,243.33Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M219.59,343H244.5"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M418.92,168.58V343"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M418.92,93.83H543.5v74.75H418.92Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M418.89,333.66a9.34,9.34,0,1,0,9.37,9.34,9.36,9.36,0,0,0-9.37-9.34"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M232,243.33a87.21,87.21,0,0,1,87.21,87.21v162"
          transform="translate(-47.24 -73.83)"
        />
      </svg>
    </Box>
  )
}

export default memo(MessengerModuleBrand)
